var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCirclePrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.176 22.3784C44.3476 23.55 44.3476 25.4495 43.176 26.6211L29.426 40.3711C28.2544 41.5426 26.3549 41.5426 25.1834 40.3711L16.9334 32.1211C15.7618 30.9495 15.7618 29.05 16.9334 27.8784C18.1049 26.7069 20.0044 26.7069 21.176 27.8784L27.3047 34.0071L38.9334 22.3784C40.1049 21.2069 42.0044 21.2069 43.176 22.3784Z",
    fill: "#774EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0547 8.25C18.0425 8.25 8.30469 17.9878 8.30469 30C8.30469 42.0123 18.0425 51.75 30.0547 51.75C42.067 51.75 51.8047 42.0123 51.8047 30C51.8047 17.9878 42.067 8.25 30.0547 8.25ZM2.30469 30C2.30469 14.6741 14.7288 2.25 30.0547 2.25C45.3807 2.25 57.8047 14.6741 57.8047 30C57.8047 45.326 45.3807 57.75 30.0547 57.75C14.7288 57.75 2.30469 45.326 2.30469 30Z",
    fill: "#774EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCirclePrimary);
export default __webpack_public_path__ + "static/media/check_circle_primary.d71f5a162ca8d8b64e4a2cdc6879a8e1.svg";
export { ForwardRef as ReactComponent };